import { Snackbar, Alert } from '@mui/material';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { toastStateSelector } from 'state';

export function GlobalToast() {
  const [toast, setToast] = useRecoilState(toastStateSelector);

  useEffect(() => {
    if (toast.isOpen) {
      setTimeout(() => {
        setToast({ isOpen: false });
      }, 5000);
    }
  }, [toast, setToast]);

  return toast.isOpen ? (
    <Snackbar
      open={toast.isOpen}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      sx={{
        mt: 6,
        zIndex: 10000,
      }}
    >
      <Alert
        variant="filled"
        severity={toast.severity}
        onClick={() => setToast({ isOpen: false })}
        data-testid="global-toast"
      >
        {toast.message}
      </Alert>
    </Snackbar>
  ) : (
    <div data-testid="global-toast-closed"></div>
  );
}
